import React from 'react';
import { Button, Image, Checkbox } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, dateFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Reminder, ReminderRepetition } from '../models/reminder';
import { ReminderService } from '../services/reminder.service';

interface IState {
  reminders: Reminder[];
  groupId: number;
  status: string;
  columns: any;
}

export class RemindersByUserPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      reminders: new Array<Reminder>(),
      groupId: 0,
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'image',
        text: 'Slika',
        formatter: (cellContent, row) => {
          return (
            <Image src={row.image} />
          );
        }
      },
      {
        dataField: 'name',
        text: 'Naziv podsjetnika',
        sort: true,
        filter: textFilter()
      }, 
      {
        dataField: 'orderKey',
        text: 'Poredak (od najmanjeg broja do najvećeg)',
        headerStyle: () => {
          return { width: '10%' };
        },
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'reminderTime',
        text: 'Vrijeme',
        sort: true,
        filter: dateFilter({
          withoutEmptyComparatorOption: true,
        }),
        formatter: (cellContent, row) => {
          return (
            new Intl.DateTimeFormat("hr-HR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            }).format(new Date(cellContent))
          );
        }
      }, 
      {
        dataField: 'isCompleted',
        text: 'Podsjetnik izvršen?',
        headerStyle: () => {
          return { width: '9%' };
        },
        sort: true,
        formatter: (cellContent, row) => {
          return (
            <Checkbox checked={row.isCompleted} disabled />
          );
        }
      },
      {
        dataField: 'isGlobal',
        text: 'Podsjetnik za sve',
        headerStyle: () => {
          return { width: '8%' };
        },
        sort: true,
        formatter: (cellContent, row) => {
          return (
            <Checkbox checked={row.userId == null} disabled />
          );
        }
      },
      {
        dataField: 'reminderRepeat',
        text: 'Ponavljanje podsjetnika',
        sort: true,
        formatter: cell => ReminderRepetition[cell],
        filter: selectFilter({
          options: [ 
            { value: ReminderRepetition['Bez ponavljanja'], label: 'Bez ponavljanja' },
            { value: ReminderRepetition['Dnevno'], label: 'Dnevno' },
            { value: ReminderRepetition['Tjedno'], label: 'Tjedno' },
            { value: ReminderRepetition['Mjesečno'], label: 'Mjesečno' },
            { value: ReminderRepetition['Godišnje'], label: 'Godišnje' },
            { value: ReminderRepetition['Radnim danom'], label: 'Radnim danom' },
          ],
          placeholder: "Odaberi filter"          
        })
      }, 
      {
        dataField: 'edit',
        isDummyField: true,
        text: 'Uredi',
        formatter: (cellContent, row) => {
          return (
            <LinkContainer to={'/reminder/edit/' + row.id}>
              <Button className="btn-primary">
                Uredi podsjetnik
              </Button>
            </LinkContainer>
          );
        }
      }]
    };
  }

  componentDidMount() {

    let id = this.props.match.params.id ? this.props.match.params.id : 0;

    if (id !== 0) {

        ReminderService.getUserReminders(id)
          .then(
            response => {
              this.setState({
                reminders: response
              });
            },
            error => {
              this.setState({
                status: error.message
              });
            }
          );
      }
  }
  
  render() {
    return (
      <div>
        <h1 className="page-title">Podsjetnici</h1>
        <div className="row form-group">
          <div className="col-md-12">
              <LinkContainer to={'/reminder/edit/'}>
                <Button className="btn-primary">
                  Kreiraj novi podsjetnik
                </Button>
              </LinkContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            { this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable 
              striped
              hover
              keyField='id' 
              data={ this.state.reminders } 
              columns={ this.state.columns }
              filter={ filterFactory() } 
              pagination={ paginationFactory() }/>
          </div>
        </div>
        <button
            className="button icon-left"
            onClick={this.props.history.goBack}>
            Povratak
        </button>
      </div>
    );
  }
}